import React from "react";

//Band of the Wix page background photo that sits behind the fixed header on the inner pages
const PageBanner = () => (
  <span
    className={"page-banner"}
    style={{ "--bg-image": "url(/images/page-header.jpg)" }}
    aria-hidden={"true"}
  />
);

export default PageBanner;
